import { RoleRepository } from '../../domain/repository';
import { RoleRepositoryImpl } from '../repository';

export const roleProviders = [
  {
    provide: RoleRepository,
    useExisting: RoleRepositoryImpl,
  },
];


